import axios from "axios";
import { BASE_API_URL,REFRESH_TOKEN_URL } from "../config/config";
import Auth from "../security/Auth";
import _ from "lodash";

const auth = new Auth();
let axiosApiInstance =  axios.create({
  baseURL: BASE_API_URL
});


let requestInterceptor=   async config => {
  let businessId = sessionStorage.getItem('business_id');
  //let businessId = BUSINESS_ID;
  if (!_.isEmpty(auth.getAccessToken())) {
    config.headers['Authorization']="Bearer "+auth.getAccessToken();
  }
  if (!_.isEmpty(businessId)){
    config.headers['business_id']=businessId;
  }
  return config;
}

axiosApiInstance.interceptors.request.use(
  requestInterceptor,
  error => {
    Promise.reject(error)}
  )

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  const isTokenExpired = error.response?.data?.expired;
  if (error.response && error.response.status === 401 && isTokenExpired && !originalRequest._retry) {
    originalRequest._retry = true;
    const refresh_token = auth.getRefreshToken();
    await axios.post(BASE_API_URL+REFRESH_TOKEN_URL, {
      refreshToken: refresh_token,
    })
    .then(function (response) {
      console.log("Updating tokens using refresh token");
      auth.updateTokens(response.data);
    })
    .catch(function (error) {
      console.log("Error encountered in renewing token"+error);
      auth.logout();
      window.location.href="../ui/logout"
    });

    const accessToken = auth.getAccessToken();
    if (accessToken){          
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
      return axiosApiInstance(originalRequest);
    }

  }
  
  return Promise.reject(error);
}); 


export {axiosApiInstance as API};
